import MicroModal from "micromodal";

// Make MicroModal available globally
window.MicroModal = MicroModal;

document.addEventListener("turbo:load", () => {
  MicroModal.init({
    openTrigger: "data-custom-open", // [3]
    closeTrigger: "data-custom-close", // [4]
    disableScroll: true,
  });
});
